<template>
  <v-list-tile class="nx-activity-item" :to="route">
    <v-list-tile-avatar>
      <v-icon class="nx-activity-item-icon" v-text="icon" />
    </v-list-tile-avatar>
    <v-list-tile-content>
      <span class="d-flex">
        <span class="nx-activity-item-type" v-text="typeText" />
        <span class="nx-activity-item-title ml-2" v-text="title" />
      </span>
    </v-list-tile-content>
  </v-list-tile>
</template>

<script>
import DashboardCard from '@/modules/dashboard/mixins/dashboard-card';
import { entityEditorRoute } from '@/modules/entity/router';
import { entityIcon, entityTypeTranslation } from '@/modules/entity/utils';
import capitalize from 'lodash/capitalize';

export default {
  name: 'nx-dashboard-activity-item',
  mixins: [DashboardCard],
  props: {
    entity: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
  },
  computed: {
    icon() {
      return entityIcon(this.entity);
    },
    typeText() {
      return capitalize(entityTypeTranslation(this.entity));
    },
    route() {
      return entityEditorRoute.get(this.entity, {
        id: this.id,
        type: this.entity,
        siteId: this.$store.getters.siteId,
      });
    },
  },
};
</script>

<style lang="stylus" scoped>
.nx-activity-item-title {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
</style>
